import { gql } from "@apollo/client";

const BULK_TRANSLATE_RECIPES = gql`
  mutation BulkTranslateRecipes($input: BulkTranslateRecipesInput!) {
    bulkTranslateRecipes(input: $input) {
      taskId
      queuedCount
      targetIndex
      language
      skipIfTranslated
    }
  }
`;

export default BULK_TRANSLATE_RECIPES;
